import { Props } from 'shared/@types';
import { H2 } from 'shared/components/title';
import { Text } from 'shared/components/text';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { View } from 'react-native';

type HowItWorksItem = {
  title: ReactNode | string;
  description: ReactNode | string;
  image: ReactNode;
};

type HowItWorksSectionProps = Props<{
  title: ReactNode | string;
  subtitle?: ReactNode | string;
  items: HowItWorksItem[];
  id?: string;
  marginTop?: boolean;
}>;

const HowItWorksSection = ({
  title,
  subtitle,
  items,
  id,
  marginTop = true,
}: HowItWorksSectionProps) => {
  return (
    <>
      <H2 id={id} title={title} subtitle={subtitle} center={true} marginTop={marginTop} />

      <View className={'mx-auto mt-3 w-full max-w-screen-md gap-6'}>
        {items.map((item, index) => (
          <View
            key={index}
            className={clsx(
              'gap-3 md:flex-row md:items-center md:gap-6',
              index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse',
            )}
          >
            <View className={'w-full md:w-2/5'}>{item.image}</View>

            <View className={'w-full md:flex-1'}>
              <Text className={'text-brand-brown-dark font-bold md:text-lg'}>
                {index + 1}. {item.title}
              </Text>
              <Text className={'text-brand-brown-dark/70 md:text-lg'}>{item.description}</Text>
            </View>
          </View>
        ))}
      </View>
    </>
  );
};

export { HowItWorksSection };
export type { HowItWorksItem, HowItWorksSectionProps };
